import React from 'react';
import { Pagination as MuiPagination, PaginationProps as MuiPaginationProps } from '@mui/material';
import { useWindowDimensions } from '@/hooks/general/useWindowDimensions/useWindowDimensions';
import { ScreenType } from '@/types/enums/media';
import styles from './pagination.module.css';

export const Pagination = (props: MuiPaginationProps) => {
    const windowDimensions = useWindowDimensions();
    const getComponentSize = () => {
        switch (windowDimensions.screenType) {
            case ScreenType.Mobile:
                return 'small';
            default:
                return 'medium';
        }
    };

    return (
        <MuiPagination
            className={styles.pagination}
            size={getComponentSize()}
            color={'primary'}
            {...props}
            data-testid="mui-pagination"
        />
    );
};
